import { type FC, createContext, useContext, useMemo, useState } from "react";

import type {
  SelectedPerimeters,
  SelectedPerimetersContextProps,
  SelectedPerimetersProviderProps,
} from "./SelectedPerimeters.types";

const SelectedPerimetersContext = createContext<SelectedPerimetersContextProps>(
  {
    selectedPerimeters: [],
    setSelectedPerimeters: () => true,
  },
);

export const SelectedPerimetersProvider: FC<
  SelectedPerimetersProviderProps
> = ({ children }) => {
  const [selectedPerimeters, setSelectedPerimeters] = useState<
    SelectedPerimeters[]
  >([]);

  const contextSelectedPerimeters = useMemo(
    () => ({
      selectedPerimeters,
      setSelectedPerimeters,
    }),
    [selectedPerimeters],
  );

  return (
    <SelectedPerimetersContext.Provider value={contextSelectedPerimeters}>
      {children}
    </SelectedPerimetersContext.Provider>
  );
};

export const useSelectedPerimeters = (): SelectedPerimetersContextProps => {
  const context = useContext(SelectedPerimetersContext);

  if (!context) {
    throw new Error(
      "useSelectedPerimeters must be used within a SelectedPerimetersProvider",
    );
  }

  return context;
};
